import cn from 'classnames';
import React from 'react';

interface SegmentBannerProps
  extends React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

function isHTML(str): boolean {
  // Simple regex to check if string contains HTML tags
  const pattern = /<\/?[a-z][\s\S]*>/i;
  return typeof str === 'string' && pattern.test(str);
}

/**
 * Segment banner to display best seller text based on segmentation
 * When the string, "bestseller" is present, it's rendered with bold style
 */
const SegmentBanner: React.FC<React.PropsWithChildren<SegmentBannerProps>> = ({
  children,
  className,
  ...others
}) => {
  let processedChildren: React.ReactNode;

  if (isHTML(children)) {
    processedChildren = (
      <span dangerouslySetInnerHTML={{ __html: children as string }} />
    );
  } else if (typeof children === 'string') {
    // Backend returns bold tag as "** some word** "
    const formattedText = children.replace(
      /\*\*(.*?)\*\*/g,
      '<span class="font-medium">$1</span>'
    );
    processedChildren = (
      <span dangerouslySetInnerHTML={{ __html: formattedText }}></span>
    );
  } else {
    processedChildren = children;
  }

  return (
    <div
      className={cn(
        'relative inline-block rounded-sm bg-badge-bestseller px-2 py-[10px] text-primary-main',
        className
      )}
      {...others}
    >
      <div className="absolute left-6 top-[-6px]  h-4 w-4 rotate-45 rounded-xs bg-badge-bestseller" />
      <span className="line-clamp-4">{processedChildren}</span>
    </div>
  );
};

export default SegmentBanner;
